import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Drawing from './pages/Drawing';
import './styles/App.css';

function App() {
  const [username, setUsername] = useState(null);

  useEffect(() => {
    // Check if user is logged in
    const savedUsername = localStorage.getItem('strokeAppUsername');
    if (savedUsername) {
      setUsername(savedUsername);
    }
  }, []);

  const handleLogin = (user) => {
    setUsername(user);
    localStorage.setItem('strokeAppUsername', user);
  };

  const handleLogout = () => {
    setUsername(null);
    localStorage.removeItem('strokeAppUsername');
  };

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={
            username ? <Navigate to="/drawing" /> : <LandingPage onLogin={handleLogin} />
          } 
        />
        <Route 
          path="/drawing" 
          element={
            username ? <Drawing username={username} onLogout={handleLogout} /> : <Navigate to="/" />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;

